import { BLOCKS } from '@contentful/rich-text-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';
import ReactPlayer from 'react-player';

import Blockquote from '../../images/icons/blockquote.png';
import * as styles from './CustomerContentBlock.module.css';
import { ArrowLink } from './Links';
import RichTextConverter from './RichText/RichTextConverter';

const options = {
  renderText: (text) =>
    text.split('\n').map((t, i) =>
      i > 0 ? (
        <>
          <br />
          {t}
        </>
      ) : (
        t
      )
    ),
  renderNode: {
    [BLOCKS.QUOTE]: (node, children) => {
      return (
        <>
          <img loading="lazy" alt="quote" src={Blockquote} className={styles.quoteImg} />
          <div className={styles.blockquote}>{children}</div>
        </>
      );
    },
  },
};

const CustomerContentBlock = ({ block, imageOnRight = false }) => {
  const isSvg = get(block, 'logo.file.contentType') === 'image/svg+xml';
  const useVideo = block.videoUrl && block.videoUrl.length > 0;
  return (
    <div className={[styles.cbContainer, imageOnRight ? styles.imgRight : ''].join(' ')}>
      {useVideo && (
        <div className={styles.playerWrapper}>
          <ReactPlayer
            className={styles.reactPlayers}
            controls={true}
            width="100%"
            height="100%"
            url={block.videoUrl}
          />
        </div>
      )}
      {!useVideo && (
        <GatsbyImage
          data-ot-ignore
          image={get(block, 'mainImage.gatsbyImageData')}
          alt={get(block, 'mainImage.title')}
          className={styles.mainImage}
          loading={'lazy'}
        />
      )}
      <div className={styles.square}>
        <div className={[styles.generalContainer, 'unordered-dash'].join(' ')}>
          {block.headerSuper && <h4>{block.headerSuper}</h4>}
          {!isSvg && (
            <GatsbyImage
              data-ot-ignore
              image={get(block, 'logo.gatsbyImageData', '')}
              imgStyle={{ objectFit: 'contain' }}
              className={styles.logo}
              loading="lazy"
              alt={'logo'}
            />
          )}
          {isSvg && <img className={styles.logoSvg} loading="lazy" src={get(block, 'logo.file.url')} alt={'logo'} />}
          <div>
            <RichTextConverter copy={block.copy} options={options} />
          </div>
          {block.attachment && (
            <div>
              <ArrowLink
                label={block.attachmentLabel}
                url={get(block, 'attachment.file.url')}
                isArrowDown
                isExternal
                isDownload
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

CustomerContentBlock.propTypes = {
  block: PropTypes.object.isRequired,
  imageOnRight: PropTypes.bool,
};

export default CustomerContentBlock;
